import type { DataMessagePartComponent } from "@assistant-ui/react";
import { useAuiState } from "@assistant-ui/react";
import { MarkdownText } from "@circle-react-shared/AiConversation/markdown/MarkdownText";
import { TiptapEditor } from "@circle-react-shared/uikit/TipTap";
import type { Message } from "@circle-react/types/CommunityInbox/Message";

import { TIPTAP_BODY_PART } from "./avatarThreadMessages";

// Without `shouldRefetch` the read-only editor ignores a replaced body.
const TiptapBodyPart: DataMessagePartComponent<Message["body"]> = ({
  data,
}) => {
  const isUserMessage = useAuiState(s => s.message.role === "user");

  return (
    <TiptapEditor
      editable={false}
      rich_text_body={data}
      shouldRefetch
      shouldShowPreviewBlocks={isUserMessage}
      shouldSupportCodeBlocks
      shouldSupportHeadings
      shouldSupportTables
    />
  );
};

// AUI's Text part contract takes no custom props, so this adapts the shared,
// configurable MarkdownText (same pattern as CircleAi's AssistantTextBubble).
const AvatarMarkdownText = () => <MarkdownText />;

// Module-level: PartByIndex memoizes on component references.
export const avatarPartComponents = {
  Text: AvatarMarkdownText,
  data: { by_name: { [TIPTAP_BODY_PART]: TiptapBodyPart } },
};
